const release = {
  "RELEASE_NOTES": "Release notes and information",
  "ALL_RELEASE_DISPLAYED": "All available information is displayed",
  "ALL_RELEASE_NOTES": "Shizen updates",
  "LATEST_ESSENTIAL_FEATURES": "Latest essential features",
  "ESSENTIAL_FEATURES": "Essential features",
  "STANDARD_FEATURES": "Standard features",
  "BUG_FIXES": "Bug fixes",
  "MINOR_BUG_FIXES": "Minor bug fixes",
  "DONT_SHOW_ESSENTIAL_AGAIN": "Don't show essential features for the current version",
  "DONT_SHOW_ANY_ESSENTIAL_AGAIN": "Don't show essential features for any version",
  "SHOW_ALL_NOTES": "Show notes of all versions",
  "RELEASE_NOTES_SETTINGS_HINT": "These settings are specific to this device only. The settings may be different on another device connected to the same account.",
  "HIDE_CURRENT_ESSENTIAL_HINT": "By checking this option, the new essential features of the current version will no longer be displayed when loading Shizen. We recommend that you check this option if you took the time to read about these.",
  "HIDE_ALL_ESSENTIAL_HINT": "By checing this option, the new essential features about any new version will no longer be displayed when loading Shizen. You should note that a new version is released every 1 or 2 weeks. We recommend that you keep this option unchecked to keep everyone informed about the newest features on this device.",
}

export default release;
